import React from 'react'
import styled from 'styled-components'
import { NonIdealState, Block, Button, H4, P } from '@mote/ui'

export const SurveyError = ({ title = 'Hmm... weird!', children }) => (
  <Container layout='vertical' align='center' justify='center' spreadX>
    <NonIdealState height={'auto'}>
      <Block layout='vertical' gap={16}>
        <H4 fontWeight={500} fontSize={20} color='#25252D'>
          {title}
        </H4>
        <P fontWeight={400} fontSize={16} lineHeight='120%' color='#6C6C84'>
          {children}
          <br />
          <br />
          If the problem persists kindly contact us at{' '}
          <Link
            tag='a'
            variant='link'
            href='mailto: support@mote.com'
            text='support@mote.com'
          />
        </P>
      </Block>
    </NonIdealState>
  </Container>
)

const Container = styled(Block)`
  padding: 60px 0;

  @media (max-width: 639px) {
    padding: 32px 0;
  }
`

const Link = styled(Button)`
  span {
    font-weight: 400;
    line-height: 120%;
  }
`
